
function NotFound() {
  return (
    <div className="max-w-3xl mx-auto py-16 px-8 text-center">
      <h1 className="h2 mb-4">404 - Page Not Found</h1>
      <p className="text-lg">Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}
export default NotFound;
